import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { theme } from '../theme';
import { PinIcon } from '../Icons';
import PageBackground from './PageBackground';

function BookingOutcome({ success }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Duffel appends order_id and reference as query params on the
  // success redirect (per their docs) — surfaced here mainly so a user
  // has a booking reference to quote if they need support later.
  const orderId = searchParams.get('order_id');

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <PageBackground variant="calm" />
      <div style={{
        background: theme.surface, borderRadius: '20px', padding: '40px 32px',
        maxWidth: '440px', textAlign: 'center', border: `1px solid ${theme.border}`
      }}>
        {/* One-shot entrance, success only — a failed booking shouldn't
            get any celebratory motion, so this whole block (icon burst +
            staggered text) is skipped entirely when success is false. */}
        <div style={{ position: 'relative', display: 'inline-block' }}>
          {success && <span className="booked-ring-burst" aria-hidden="true" />}
          <PinIcon
            size={44}
            color={success ? theme.structural : theme.danger}
            style={{ marginBottom: '12px', position: 'relative', ...(success ? { animation: 'bookedPop 0.5s cubic-bezier(.2,.9,.3,1.3)' } : {}) }}
          />
        </div>
        <h1
          style={{
            fontFamily: "'Quicksand', sans-serif", fontSize: '24px', fontWeight: 700, color: theme.textPrimary, margin: '0 0 8px',
            ...(success ? { animation: 'bookedPop 0.5s cubic-bezier(.2,.9,.3,1.3) 0.08s backwards' } : {})
          }}
        >
          {success ? 'Booked!' : "Something didn't go through"}
        </h1>
        <p style={{ fontSize: '14px', color: theme.textMuted, margin: '0 0 4px' }}>
          {success
            ? "Your booking is confirmed. Check your email for your e-ticket and full itinerary."
            : "Your booking couldn't be completed. You haven't been charged."}
        </p>
        {success && orderId && (
          <p style={{ fontSize: '12px', color: theme.textMuted, marginTop: '10px' }}>
            Booking reference: <strong>{orderId}</strong>
          </p>
        )}
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            marginTop: '24px', width: '100%', background: theme.action, color: theme.cream,
            border: 'none', borderRadius: '10px', padding: '13px', fontWeight: 700, fontSize: '14px',
            cursor: 'pointer', fontFamily: "'Quicksand', sans-serif"
          }}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}

export default BookingOutcome;